import { BasePreview } from './BasePreview';
export function UnknownPreview() {
    return <BasePreview disableZoom/>;
}
